import AnchorLink from 'antd/es/anchor/AnchorLink';
export default AnchorLink;
